import React, { useCallback, useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { SelectFilter } from "@skydio/rivet-ui";

import { useArraySearchParam } from "hooks/searchParams";

import { useConnectionNodes } from "../Pagination";

import type { FC } from "react";
import type { LoginTypeFilter_orgIdps$key } from "__generated__/LoginTypeFilter_orgIdps.graphql";

export const idpsFragment = graphql`
  fragment LoginTypeFilter_orgIdps on Organization {
    identityProviderConfigurations {
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`;

interface Props {
  label?: string;
  idpDataRef: LoginTypeFilter_orgIdps$key;
  onSelect?: () => void;
  paramKey: string;
}

const LoginTypeFilter: FC<Props> = ({ label, idpDataRef, onSelect, paramKey }) => {
  const [selectedLoginTypes, setSelectedLoginTypes] = useArraySearchParam(paramKey);

  const idps_query_results = useFragment(idpsFragment, idpDataRef);
  const idps = useConnectionNodes(idps_query_results.identityProviderConfigurations);

  const items = useMemo(
    () => [
      { key: "Email", label: "Email" },
      ...idps.map(idp => ({ key: idp.uuid, label: idp.name })),
    ],
    [idps]
  );

  const handleSelectionChange = useCallback(
    (keys: Set<string | number>) => {
      setSelectedLoginTypes(Array.from(keys) as string[]);
      onSelect?.();
    },
    [setSelectedLoginTypes, onSelect]
  );

  const renderItem = useCallback(
    (item: { key: string; label: string }) => (
      <SelectFilter.Item key={item.key}>{item.label}</SelectFilter.Item>
    ),
    []
  );

  return (
    <SelectFilter
      selectionMode="multiple"
      placeholder="Login Method"
      filterLabel={label ?? "Login Method"}
      selectedKeys={selectedLoginTypes}
      items={items}
      onSelectionChange={handleSelectionChange}
    >
      {renderItem}
    </SelectFilter>
  );
};

export default LoginTypeFilter;
